import React from 'react';
import './HistoryDetailLayout.scss';

export type HistoryDetailLayoutProps = {
    historyTitle: string;
    historyIcon?: React.ReactNode;
    historyTop?: React.ReactNode;
    detailTitle: string;
    detailIcon?: React.ReactNode;
    history: React.ReactNode;
    detail: React.ReactNode;
};

export const HistoryDetailLayout: React.FC<HistoryDetailLayoutProps> = ({
    historyTitle,
    historyIcon,
    historyTop,
    detailTitle,
    detailIcon,
    history,
    detail
}) => {
    return (
        <div className="history-detail-layout">
            <aside className="history-detail-layout__history">
                {historyTop && <div className="history-detail-layout__history-top">{historyTop}</div>}
                <header className="history-detail-layout__section-header">
                    {historyIcon && <span aria-hidden="true">{historyIcon}</span>}
                    <h2>{historyTitle}</h2>
                </header>
                <div className="history-detail-layout__history-body">{history}</div>
            </aside>
            <section className="history-detail-layout__detail">
                <header className="history-detail-layout__section-header">
                    {detailIcon && <span aria-hidden="true">{detailIcon}</span>}
                    <h2>{detailTitle}</h2>
                </header>
                <div className="history-detail-layout__detail-body">{detail}</div>
            </section>
        </div>
    );
};
